import type { FC, ReactChild } from 'react';
import React from 'react';

import type { Shortcuts } from './../ricos-shortcuts/editor-keyboard-shortcuts';

type ShortcutsContextProps = {
  shortcuts: Shortcuts;
  children: ReactChild;
};

export const ShortcutsContext = React.createContext<Shortcuts>(null as unknown as Shortcuts);

export const ShortcutsContextProvider: FC<ShortcutsContextProps> = ({ shortcuts, children }) => (
  <ShortcutsContext.Provider value={shortcuts}>{children}</ShortcutsContext.Provider>
);
